/*
 * @Copyright: @ Silk Software Corp. All Rights Reserved Based on MIT-LICENSE
 */
import { gql } from '@apollo/client'

export const B3_GET_COMPANY = gql`
  query getCompany($userId: Int!) {
    userCompany(userId: $userId) {
      id
      companyName
      bcGroupName
      description
      catalogId
      companyStatus
      addressLine1
      addressLine2
      city
      state
      zipCode
      country
      extraFields {
        fieldName
        fieldValue
      }
    }
  }
`
